export const LISTING_PER_PAGE = 12
export const ASSETS_URL = "/assets"
